<template>
  <v-container id="atualizacoes-dda-historico" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-file-document-edit-outline"
          inline
          class="ml-0 px-5 py-4"
          title="Ajustes de DDA"
        >
          <v-row>
            <v-col cols="12">
              <registros-por-tabela-data-table :itemsPerPage="10" :items="items" />
            </v-col>
            <v-col cols="12">
              <logs-ajustes-manuais-tabelas-data-table tipo="dda" />
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AtualizacoesTabelasService from '@/services/AtualizacoesTabelasService';

  export default {
    name: 'AtualizacoesDdaHistorico',
    components: {
      RegistrosPorTabelaDataTable: () => import('@/components/general/data-tables/RegistrosPorTabelaDataTable.vue'),
      LogsAjustesManuaisTabelasDataTable: () =>
        import('@/components/geracao-bdgd/atualizacoes-tabelas/LogsAjustesManuaisTabelasDataTable')
    },
    mixins: [],
    data: () => ({
      items: []
    }),
    computed: {},
    mounted() {
      this.getTabelasDda();
    },
    methods: {
      getTabelasDda() {
        AtualizacoesTabelasService.getTabelasDda()
          .then((response) => {
            this.items = response.data.map((item) => {
              return {
                ...item,
                link: `/geracao-bdgd/atualizacoes-dda/visualizar/${item.tabela.toLowerCase()}`
              };
            });
          })
          .catch((error) => {
            this.$toast.error('Erro ao recuperar as tabelas de DDA .', '', { position: 'topRight' });
            console.error(error);
          });
      }
    }
  };
</script>
